import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "documentItemModal p-8 flex flex-col justify-between" }
const _hoisted_2 = { class: "documentItemModalContent" }
const _hoisted_3 = { class: "sectionItem mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Name ", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "sectionItem mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Description ", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "buttonPart flex flex-row gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_AppInput, {
                modelValue: _ctx.data.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.name) = $event)),
                placeholder: 'Type...'
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_AppInput, {
                modelValue: _ctx.data.description,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.description) = $event)),
                placeholder: 'Type...'
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_AButton, {
            class: "p-2 grow",
            "btn-secondary": true,
            onClick: _ctx.deleteDocument
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Delete ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_AButton, {
            class: "p-2 grow",
            "btn-primary": true,
            onClick: _ctx.uploadDocument
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Upload ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}